/* @flow */

import React from 'react';

import * as emailDomainsPermissions from 'permissions/emailDomains';
import EmailDomainForm from 'forms/EmailDomainForm';
import EmailDomainsReportView from 'tables/EmailDomainsReportView/EmailDomainsReportView';

import type { TypeComponent } from './types';
import { getStore } from '../services/ServiceRegistry';

const emailDomainRoutes = [
  {
    path: '/email-domains',
    title: 'general:document_titles.email_domains.title',
    component: EmailDomainsReportView,
    exact: true,
    permissions: emailDomainsPermissions.read,
  },
  {
    path: '/email-domains/create',
    title: 'general:document_titles.email_domains.create',
    component: function emailDomainsForm(props: Object): TypeComponent {
      return <EmailDomainForm variant="new" />;
    },
    exact: true,
    permissions: emailDomainsPermissions.create,
  },
  {
    path: '/email-domains/edit',
    title: 'general:document_titles.email_domains.edit',
    title_keys: ['selectedEmailDomain.domain'],
    component: function emailDomainsForm(props: Object): TypeComponent {
      const {
        location: { state: domain },
      } = props;
      const store = getStore(['emailDomainsStore'])[0];

      store.selectedEmailDomain = domain;

      return <EmailDomainForm variant="edit" domain={domain} />;
    },
    exact: true,
    permissions: emailDomainsPermissions.update,
  },
];

export default emailDomainRoutes.map(item => ({
  ...item,
  store: ['emailDomainsStore'],
}));
